import React, { useEffect, useState } from 'react'
import { UISelect } from '../form-fields'

export const UIDropdown = (props) => {
  return <UISelect {...props} dropdown={true} />
}
